"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AuthorizationPanel_1 = __importDefault(require("./AuthorizationPanel"));
exports.default = AuthorizationPanel_1.default;
